var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpcomingDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6733 13.9052C4.67303 13.9055 4.67303 13.9059 4.6733 13.9062L5.30919 14.5421C5.66067 14.8935 6.23053 14.8935 6.582 14.5421L11.6302 9.49387C11.9817 9.14239 11.9817 8.57255 11.6302 8.22107C11.2787 7.8696 10.7089 7.8696 10.3574 8.22107L6.65368 11.9248C6.26316 12.3153 5.62999 12.3153 5.23947 11.9248L1.53721 8.22254C1.18574 7.87107 0.615893 7.87107 0.264421 8.22254C-0.0870499 8.57401 -0.0870509 9.14386 0.264421 9.49533L4.6733 13.9042C4.67356 13.9045 4.67356 13.9049 4.6733 13.9052Z",
    fill: "#FDDF6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.67256 5.94815C4.67229 5.94842 4.67229 5.94886 4.67256 5.94913L5.30846 6.58502C5.65994 6.9365 6.22979 6.9365 6.58127 6.58502L11.6295 1.53683C11.9809 1.18536 11.9809 0.615514 11.6295 0.264042C11.278 -0.0874296 10.7081 -0.0874292 10.3567 0.264042L6.65295 3.96776C6.26243 4.35829 5.62926 4.35829 5.23874 3.96776L1.53648 0.265506C1.18501 -0.0859651 0.615161 -0.0859657 0.263689 0.265506C-0.0877823 0.616978 -0.0877833 1.18683 0.263689 1.5383L4.67256 5.94717C4.67283 5.94744 4.67283 5.94788 4.67256 5.94815Z",
    fill: "#FDDF6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingDropdown);
export default __webpack_public_path__ + "static/media/UpcomingDropdown.2dfd9ce9e858ef63c0b1447ce6708f1c.svg";
export { ForwardRef as ReactComponent };